import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({ template: '' })
export class AbstractControlValueAccessorComponent {
    @Input() id: string;
    @Input() title: string;
    @Input() disabled: boolean;
    @Input() readonly: boolean;
    @Input() ariaLabel: string;
    @Input() ariaInvalid: string;
    @Input() placeholder: string;
    @Input() hintMessage: string;
    @Input() hintType: 'default' | 'success' | 'warning' | 'error' = 'default';
    @Input() required: boolean;

    @ViewChild('labelElement') labelElement: ElementRef;

    public REQUIRED_SIGN = ' *';

    get label() {
        return this.labelElement?.nativeElement?.innerText.replace(this.REQUIRED_SIGN, '');
    }

    get errorLabel() {
        return this.title ? this.title : this.label;
    }

    protected innerValue = '';

    get value(): string {
        return this.innerValue;
    }

    set value(value: string) {
        if (value !== this.innerValue) {
            this.writeValue(value.replace(/<[^>]*>/g, ''));
        }
    }

    // Generated
    propagateChange(value: string) {}

    registerOnChange(fn: (value: string) => void): void {
        this.propagateChange = fn;
    }

    propagateTouch() {}

    registerOnTouched(fn: () => void): void {
        this.propagateTouch = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(value: string): void {
        if (value !== undefined) {
            this.innerValue = value;
            this.propagateChange(this.value);
        }
    }
}
